import React, { type ComponentType } from 'react';

import type { LinkQueryResult } from './traceInspector.types';

type TraceInspectorContextType = {
  links: LinkQueryResult[];
  traceId: string;
  currentHash: string;
};

export const TraceInspectorContext =
  React.createContext<TraceInspectorContextType | null>(null);

export type WithTraceInspector<GenericProps extends Record<string, unknown>> =
  GenericProps & { traceInspectorContext: TraceInspectorContextType };

/**
 * HOC to inject the traceInspectorContext into the component
 * @param Component - The component to inject the traceInspectorContext into
 * @returns The component with the traceInspectorContext injected
 */
export const withTraceInspectorContext =
  <GenericProps extends Record<string, unknown>>(
    Component: ComponentType<GenericProps>
  ): ComponentType<GenericProps> =>
  (props: GenericProps) => (
    <TraceInspectorContext.Consumer>
      {value => <Component {...props} traceInspectorContext={value} />}
    </TraceInspectorContext.Consumer>
  );
